<div [formGroup]="form">
    <div formControlName="content" [froalaEditor]="froalaOptions"></div>
</div>